/** HeatmapChart — tier-2 adapter. Magnitude uses the sequential ramp. */
import { useMemo } from 'react';
import { Chart, type ChartBaseProps } from './Chart';
import type { ChartConfig } from './types';

export interface HeatmapChartProps extends ChartBaseProps {
  /** Field name for the column axis. */
  xKey: string;
  /** Field name for the row axis. */
  yKey: string;
  /** Field name holding the cell magnitude. */
  valueKey: string;
  title?: string;
}

export function HeatmapChart({ xKey, yKey, valueKey, title, ...rest }: HeatmapChartProps) {
  const config: ChartConfig = useMemo(
    () => ({
      title,
      chartType: 'heatmap',
      series: [
        { id: valueKey, name: title ?? valueKey, fields: { x: xKey, y: yKey, value: valueKey } },
      ],
    }),
    [xKey, yKey, valueKey, title],
  );
  return <Chart config={config} {...rest} />;
}
